import React, { Fragment, useEffect, useState } from "react";

import Box from "@mui/material/Box";
import "./Chalan.css";
import ShowChalan from "./ShowChalan";
import ShowLocalChalans from "./ShowLocalChalans";
import { fetchchallans, fetchLocalchallans } from "./ChalanList";
import { Tab, Tabs } from "@mui/material";
import LoadingComponent from "../../utils/Components/Loading/Loading";
// import { chalanList,localChalanList } from './ChalanList';

// const style = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: 400,
//   bgcolor: "background.paper",
//   border: "2px solid #000",
//   boxShadow: 24,
//   p: 4,
// };

const Chalans = () => {
  // const [open, setOpen] = React.useState(false);
  // const handleOpen = () => setOpen(true);
  // const handleClose = () => setOpen(false);
  const [tabValue, setTabValue] = useState("main-chalan");
  const [mainchallan, setmainchallan] = useState([]);
  const [localchallan, setlocalchallan] = useState([]);
  // console.log("mainchallan", mainchallan);

  const handleTabChange = (event, value) => {
    setTabValue(value);
  };

  useEffect(() => {
    const loadData = async () => {
      const data = await fetchchallans();
      console.log("data form chalans send to showchalans : ", data);
      setmainchallan(data);
      mainchallan.reverse();
    };
    loadData();
  }, []);
  useEffect(() => {
    const loadData = async () => {
      const data1 = await fetchLocalchallans();
      console.log("data from local challan : ", data1);
      setlocalchallan(data1);
      localchallan.reverse();
    };
    loadData();
  }, []);

  if (
    !mainchallan ||
    !localchallan ||
    (!mainchallan.length && !localchallan.length)
  ) {
    return <LoadingComponent />;
  }

  return (
    <>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          margin: "1vmax",
          marginBottom: "2vmax",
        }}
      >
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="tabs"
          centered
        >
          <Tab
            label={<h3>Main Challan</h3>}
            id={`tab-main-chalan`}
            aria-controls={`tabpanel-main-chalan`}
            value={"main-chalan"}
          />
          <Tab
            label={<h3>Freight Challans</h3>}
            id={`tab-local-chalan`}
            aria-controls={`tabpanel-local-chalan`}
            value={"local-chalan"}
          />
        </Tabs>
      </Box>
      <Box
        role="tabpanel"
        hidden={tabValue !== "main-chalan"}
        id={`tabpanel-main-chalan`}
        aria-labelledby={`tab-main-chalan`}
        className="ch-list-container"
      >
        {tabValue === "main-chalan"
          ? Object.values(mainchallan)
              .reverse()
              .map((item, index) => {
                while (index <= 4) {
                  console.log("index : ", index);
                  return (
                    <Fragment key={index}>
                      <ShowChalan challan={item[1]} />
                    </Fragment>
                  );
                }
              })
          : null}
      </Box>
      <Box
        role="tabpanel"
        hidden={tabValue !== "local-chalan"}
        id={`tabpanel-local-chalan`}
        aria-labelledby={`tab-local-chalan`}
        className="ch-list-container"
      >
        {tabValue === "local-chalan"
          ? localchallan &&
            Object.values(localchallan)
              .reverse()
              .map((item, index) => {
                while (index <= 4) {
                  return (
                    <Fragment key={index}>
                      <ShowLocalChalans localchallan={item[1]} />
                    </Fragment>
                  );
                }
              })
          : null}
      </Box>
    </>
  );
};

export default Chalans;
